import React, { useMemo, useEffect, useState } from 'react'
import {
    CModal,
    CModalBody,
    CModalHeader,
    CCol,
    CRow,
    CInput,
    CLabel,
    CModalTitle,
    CButton
} from '@coreui/react'
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import { saveUserFeedback } from 'src/actions/chat';
import { getUserId } from 'src/util/miscUtil';
import { SAVE_USER_FEEDBACK_DEFAULT } from 'src/actions/actionTypes';
import ToastMessage from 'src/components/toast-message/ToastMessage';
import { useDropzone } from "react-dropzone";

const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
};

const activeStyle = {
    borderColor: "#2196f3",
};

const acceptStyle = {
    borderColor: "black",
};

const rejectStyle = {
    borderColor: "red",
};

const UserFeedback = () => {
    const [showFeedBack, setshowFeedBack] = useState(true)
    const dispatch = useDispatch()
    const feedbackSaveStatus = useSelector(state => state?.chatReducer?.feedbackSaveStatus)
    const onFeedBackModalClose = () => {
        setshowFeedBack(!showFeedBack)
    }
    const [showToast, setshowToast] = useState(false);
    const [responseMsg, setResponseMsg] = useState('');
    const [ToastSeverity, setToastSeverity] = useState('');
    useEffect(() => {
        if (feedbackSaveStatus === 2) {
            setshowFeedBack(!showFeedBack)
            setshowToast(true)
            setResponseMsg('Feedback Successfully Submitted');
            setToastSeverity('success');
            dispatch({
                type: SAVE_USER_FEEDBACK_DEFAULT
            })
        } else if (feedbackSaveStatus === 3) {
            setshowToast(true)
            setResponseMsg('Something went wrong');
            setToastSeverity('error');
        }
        setTimeout(() => {
            setshowToast(false)
        }, 3000);
    }, [feedbackSaveStatus])
    const [submitLoader, setsubmitLoader] = useState(false)
    const validationSchema = yup.object().shape({
        title: yup
            .string()
            .max(100, 'Titel must be below 100 characters')
            .required("Title is required"),
        description: yup
            .string()
            .max(500, 'Description must be below 500 characters')
            .required("Description is required")
    });
    const saveFeedBack = (values) => {
        let uId = getUserId()
        const formdata = new FormData()
        formdata.append('title', values.title)
        formdata.append('description', values.description)
        formdata.append('user_id', uId)
        formdata.append('feedback_type', "Gst")
        for (let f of files) {
            formdata.append("files", f);
        }
        dispatch(saveUserFeedback(formdata))
        setsubmitLoader(true)
    }
    const [files, setFiles] = useState([]);
    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
    } = useDropzone({
        // accept: "image/*",
        onDrop: (acceptedFiles) => {
            setFiles(acceptedFiles);
        },
    });

    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isDragActive ? activeStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isDragActive, isDragReject, isDragAccept]
    );
    const deleteFile = (file, files, i) => {
        const newFiles = [...files];     // make a var for the new array
        newFiles.splice(i, 1);        // remove the file from the array
        setFiles(newFiles)
    }
    const renderFilesList = files.map((file, i) => (
        <li key={file.name}>
            {file.name} - {file.size} bytes
            <label className="checkbox ml-1"> <i className="fa fa-times" onClick={e => deleteFile(file, files, i)}></i></label>
        </li>
    ));

    return (
        <>
            <CModal
                show={showFeedBack}
                centered
                size=""
                onClose={() => onFeedBackModalClose()}
                color="dark right feed-back-modal"
                closeOnBackdrop={false}
            >
                <CModalHeader closeButton className="border-bottom-0 modal-header bg-grey-color">
                    <CModalTitle className="bold-label">
                        <span className="status-font">We would love to hear from you !</span>
                    </CModalTitle>
                </CModalHeader>
                <Formik
                    initialValues={{
                        title: "",
                        description: ""
                    }}
                    validationSchema={validationSchema}
                    onSubmit={((values) => {
                        saveFeedBack(values)
                    })}
                >
                    {({ handleChange, handleSubmit, handleBlur, errors, touched, values }) => (
                        <>
                            <CModalBody className="p-4 text-left less-modal-bold light-login-bg">

                                <div>
                                    <form onSubmit={handleSubmit}>
                                        <CRow >
                                            <CCol md="12" className="mb-2">
                                                <CLabel className="bold-label mb-1">Title</CLabel>
                                                <CInput type="text" placeholder="Title" onChange={handleChange} onBlur={handleBlur} name="title" autoComplete="title" className="custom-input" />
                                                {errors.title && touched.title ? (<div className="mb-1 sign-error-msgs text-danger text-left">{errors.title}</div>) : null}
                                            </CCol>

                                            <CCol md="12" className="mb-0">
                                                <CLabel htmlFor="description" className="bold-label mb-1">Description</CLabel>
                                                <textarea rows="3" className="form-control" placeholder="Description" onChange={handleChange} onBlur={handleBlur} name="description"></textarea>
                                                <div className="row mt-1">
                                                    <div className="col-8">
                                                        {errors.description && touched.description ? (<div className="mb-1 sign-error-msgs text-danger text-left">{errors.description}</div>) : null}
                                                        {!(errors.description && touched.description) && values?.description?.length > 500 ? (<div className="mb-1 sign-error-msgs text-danger text-left">{"Description must be below 500 characters"}</div>) : null}
                                                    </div>
                                                    <div className="col-4">
                                                        <div className={values?.description?.length > 500 ? "mb-1 sign-error-msgs text-danger text-right" : "mb-1 sign-error-msgs text-success text-right"}>{(values?.description?.length || 0) + "/" + 500}</div>
                                                    </div>
                                                </div>


                                            </CCol>
                                            <CCol md="12" className="mb-2 att-feed">
                                                <CLabel className="bold-label mb-1">Attachment(s)</CLabel>
                                                <div {...getRootProps({ style })}>
                                                    <input  {...getInputProps()} />
                                                    <p>Drag 'n' drop some files here, or click to select files</p>
                                                </div>
                                                <aside>
                                                    {renderFilesList?.length > 0 && <h4>Files</h4>}
                                                    <ul>{renderFilesList}</ul>
                                                </aside>
                                            </CCol>

                                        </CRow>
                                    </form>
                                </div>

                            </CModalBody>
                            <div className="modal-footer border-0  box-top-shadow">
                                <CRow>
                                    <CCol md="12">
                                        <div className="text-right mt-1">
                                            {!submitLoader && <CButton className="btn btn-block btn-primary btn-md shadow-none" type="submit" onClick={handleSubmit}><i className="fas fa-check"></i> Submit</CButton>}
                                            {submitLoader && <CButton className="btn btn-block btn-primary btn-md shadow-none" type="button" ><i className="fa fa-circle-o-notch fa-spin"></i> Submit</CButton>}
                                        </div>
                                    </CCol>
                                </CRow>
                            </div>
                        </>
                    )}
                </Formik>
            </CModal>
            {showToast && (
                <ToastMessage
                    severity={ToastSeverity}
                    summary={ToastSeverity ? "Success" : "Error"}
                    detail={responseMsg}
                />
            )}
        </>
    )

}

export default UserFeedback